import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useFormikContext, useField } from 'formik'
import { useCallback, useMemo, useEffect } from 'react'

export type BestContactTimeOptionsType = {
  label: string
  value: string
}

const options = [
  { label: 'Morning', value: 'morning' },
  { label: 'Afternoon', value: 'afternoon' },
  { label: 'Evening', value: 'evening' },
  { label: 'Weekend', value: 'weekend' },
]

export function useData({ required, name }) {
  const {
    setFieldValue,
    isSubmitting,
    values: { preferredTimeOfContact },
  } = useFormikContext<IAddOpportunityFormModel>()

  const [{}, { error, touched }] = useField<string[]>({
    name,
    validate: (value) => {
      if (required && (!value || value.length === 0)) {
        return 'Required'
      }
    },
  })

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  const renderSummary = useCallback(
    (options: BestContactTimeOptionsType[], text: string) => {
      if (options.length === 1) {
        return options[0].label
      } else {
        return `${options.length} ${text}`
      }
    },
    [],
  )

  const getOptionLabel = useCallback((option: BestContactTimeOptionsType) => {
    const index = options.findIndex((row) => row.value == option.value)
    return `(${index}) ${option.label}`
  }, [])

  const getId = useCallback((option: BestContactTimeOptionsType) => {
    return String(option.value)
  }, [])

  useEffect(() => {
    if (
      preferredTimeOfContact?.length == 0 &&
      required &&
      options?.length == 1
    ) {
      setFieldValue(name, [options[0].value])
    }
  }, [preferredTimeOfContact, required, setFieldValue])

  const initialOption = useMemo(() => {
    if (preferredTimeOfContact && preferredTimeOfContact?.length > 0) {
      const value = options.filter((x) =>
        preferredTimeOfContact?.includes(x.value),
      )
      if (value) return value
    }
    return []
  }, [options, preferredTimeOfContact])

  return {
    getOptionLabel,
    getId,
    renderSummary,
    options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
